import { getErrorMsgAndCode, validateInput } from "./FrontendHelpers";
import api from "./axios";

const checkInput = (formData) => {
  return validateInput(
    [...Object.entries(formData)]
      .filter(
        ([key]) =>
          key !== "CompanyID" &&
          key !== "OwnerName" &&
          key !== "IsActive" &&
          key !== "OwnerID"
      )
      .map(([key, value]) => {
        return {
          Name: key,
          Type: "string",
          Value: value,
          MaxLengthType: "name",
          OnlyCheckLength: true,
          MinLength: key === "Name" ? 1 : 0,
        };
      })
  );
};

export async function GetCompanyData() {
  try {
    const response = await api.get("/getCompanyData");
    const data = response.data;
    return [data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function EditCompanyData(formData) {
  try {
    const inputErrorObj = checkInput(formData);
    if (inputErrorObj.errCode !== 0) return [null, inputErrorObj];
    await api.post("/editCompanyData", formData);
    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function DeleteCompany(CompanyID) {
  try {
    console.log("Delete hook called ");
    const data = { CompanyID };

    await api.post("/deleteCompany", data);
    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
